<template>
  <nut-pull-refresh v-model="refresh" @refresh="refreshFun">
    <div class="list-info">
      <div v-for="item in list" :key="item.id">
        <div class="dis-ac">
          <div class="mr-10 dis-ac" @click="item.check = !item.check">
            <div v-if="!item.check" style="width: 15px; height: 15px; border: 1px solid #75787b">
            </div>
            <img v-else src="../../assets/img/duoxuan.svg" alt="" />
          </div>
          <div style="flex: 1">
            <slot name="list" :item="item" />
          </div>
        </div>
      </div>
    </div>
  </nut-pull-refresh>
  <div class="dis-asb fixed-button" style="justify-content: space-between">
    <div v-if="!arr" @click="allFunc(true)" class="dis-ac">
      <div style="width: 15px; height: 15px; border: 1px solid #75787b"> </div>
      <span class="ml-10">全选</span>
    </div>
    <div v-else @click="allFunc(false)" class="dis-ac">
      <img src="../../assets/img/duoxuan.svg" alt="" />
      <span class="ml-10">取消</span>
    </div>
    <div style="color: #b1b3b3">{{ select.length }}/{{ count }}</div>
    <slot name="rightButton" />
  </div>
</template>

<script setup>
  const refresh = ref(false)
  const refreshFun = () => {
    setTimeout(() => {
      refresh.value = false
    }, 1000)
  }
  const emit = defineEmits([])

  const { list } = defineProps({
    list: {
      type: Object,
      require: true
    }
  })
  function allFunc(allse) {
    list.forEach((element) => {
      element.check = allse
    })
    arr.value = allse
  }
  const count = ref(0)
  const select = ref([])
  const arr = ref(false)

  watch(
    () => list,
    (val) => {
      const count1 = val.length
      const select1 = val.filter((item) => item.check).map((item) => item.id)
      count.value = count1
      select.value = select1
      arr.value = count1 === select1.length
    },
    {
      immediate: true,
      deep: true
    }
  )
</script>

<style lang="scss" scoped>
  .list-info {
    padding: 10px 16px;
  }
</style>
